(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropoutfit-arrival-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('df-arrival-tabs')) {
  customElements.define('df-arrival-tabs', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.df-arrivals__panel');
      this.tabs = Array.from(this.querySelectorAll('.df-arrivals__tab'));
      if (!this.panel || !this.tabs.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.df-arrivals__tabs').setAttribute('role', 'tablist');
      this.panel.setAttribute('role', 'tabpanel');
      this.panel.tabIndex = 0;
      this.selected = this.panel.dataset.initialTab;
      this.tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panel.id);
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); this.select(tab);
        }, options);
        tab.addEventListener('keydown', event => {
          const index = this.tabs.indexOf(tab);
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.tabs[next].focus({ preventScroll: true });
          this.select(this.tabs[next]);
        }, options);
      });
      this.update();
    }
    select(tab) {
      if (tab.dataset.tab === this.selected) return;
      const template = this.querySelector(`template[data-panel="${tab.dataset.tab}"]`);
      if (!template) return;
      const previousTemplate = this.querySelector(`template[data-panel="${this.selected}"]`);
      if (previousTemplate) previousTemplate.content.replaceChildren(...this.panel.childNodes);
      this.panel.replaceChildren(...template.content.childNodes);
      this.selected = tab.dataset.tab;
      this.update();
    }
    update() {
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === this.selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active) this.panel.setAttribute('aria-labelledby', tab.id);
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropoutfit-collection-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('df-collection-slider')) {
  customElements.define('df-collection-slider', class extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.df-collection-slider__card'));
      if (this.cards.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.userPaused = false;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.mobile = matchMedia('(max-width: 768px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.dots = Array.from(this.querySelectorAll('.df-collection-slider__dot'));
      this.querySelectorAll('[data-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => this.move(Number(button.dataset.step)), options);
      });
      this.querySelector('.df-collection-slider__footer').hidden = false;
      this.cards.forEach((card, index) => card.addEventListener('click', event => {
        if (this.swiped) { event.preventDefault(); this.swiped = false; return; }
        if (index !== this.index) { event.preventDefault(); this.select(index, true); }
      }, options));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index, true), options));
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      const viewport = this.querySelector('.df-collection-slider__viewport');
      viewport.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
        this.start = { x: event.clientX, y: event.clientY };
        this.swiped = false;
      }, options);
      viewport.addEventListener('pointerup', event => {
        if (!this.start) return;
        const dx = event.clientX - this.start.x;
        const dy = event.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.swiped = true; this.move(dx < 0 ? 1 : -1);
        }
      }, options);
      viewport.addEventListener('pointercancel', () => { this.start = null; }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.mobile.addEventListener('change', () => this.render(), options);
      this.reduced.addEventListener('change', () => this.schedule(), options);
      this.toggle = this.querySelector('.df-collection-slider__toggle');
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.firstElementChild.textContent = this.userPaused ? '▶' : 'Ⅱ';
        this.schedule();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: .2 });
      this.observer.observe(this);
      this.classList.add('is-ready');
      this.render();
    }
    move(step) { this.select((this.index + step + this.cards.length) % this.cards.length, true); }
    select(index, announce) {
      this.index = index;
      this.render();
      if (announce) this.querySelector('.df-collection-slider__status').textContent = this.cards[index].dataset.label;
      this.schedule();
    }
    render() {
      const count = this.cards.length;
      const offsets = this.mobile.matches ? [0, 155, 270, 370] : [0, 280, 450, 560];
      this.cards.forEach((card, index) => {
        let distance = (index - this.index + count) % count;
        if (distance > count / 2) distance -= count;
        const depth = Math.abs(distance);
        const shown = depth <= 2;
        const scale = depth === 0 ? 1 : depth === 1 ? .84 : .72;
        const offset = Math.sign(distance) * offsets[Math.min(depth, 3)];
        card.style.transform = `translateX(calc(-50% + ${offset}px)) scale(${scale})`;
        card.style.opacity = shown ? '1' : '0';
        card.style.zIndex = String(10 - depth);
        card.style.filter = depth ? 'brightness(.9)' : 'none';
        card.style.pointerEvents = shown ? 'auto' : 'none';
        card.tabIndex = index === this.index ? 0 : -1;
        card.setAttribute('aria-hidden', shown ? 'false' : 'true');
      });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.userPaused || this.reduced.matches || !this.visible || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => this.select((this.index + 1) % this.cards.length, false), 4500);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropoutfit-intent-circles"] && !Shopify.designMode) return;
  try {
    
  function initFindCarousel(root) {
    root.querySelectorAll('.df-find').forEach(function (section) {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      const track = section.querySelector('.df-find__scroller');
      const previous = section.querySelector('.df-find__arrow--prev');
      const next = section.querySelector('.df-find__arrow--next');
      function updateArrows() {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      }
      function move(direction) {
        const item = track.querySelector('.df-find__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
      let startX = 0;
      let startScroll = 0;
      let pressed = false;
      let dragged = false;
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pressed = true;
        dragged = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (event) {
        if (!pressed) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 5) return;
        if (!dragged) {
          dragged = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        track.scrollLeft = startScroll - distance;
        event.preventDefault();
      });
      function finish() { pressed = false; track.classList.remove('is-dragging'); }
      track.addEventListener('pointerup', finish);
      track.addEventListener('pointercancel', finish);
      track.addEventListener('click', function (event) {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
    });
  }
  initFindCarousel(document);
  document.addEventListener('shopify:section:load', function (event) { initFindCarousel(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropoutfit-static-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drop-video-hero')) {
    customElements.define('drop-video-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.videoStage = this.querySelector('.drop-static-hero__video-stage');
        this.banner = this.querySelector('.drop-static-hero__banner-stage');
        if (!this.videoStage || !this.banner) return;
        this.controller = new AbortController();
        this.mediaQuery = window.matchMedia('(min-width: 700px)');
        this.onBreakpointChange = () => this.startVideo();
        this.mediaQuery.addEventListener('change', this.onBreakpointChange);
        this.startVideo();
      }
      startVideo() {
        this.playbackController?.abort();
        this.playbackController = new AbortController();
        const signal = this.playbackController.signal;
        clearTimeout(this.hideTimer);
        clearTimeout(this.repeatTimer);
        this.video?.pause();
        this.videoStage.replaceChildren();
        this.videoStage.hidden = true;
        this.videoStage.inert = false;
        this.videoStage.removeAttribute('aria-hidden');
        this.banner.inert = false;
        this.banner.removeAttribute('aria-hidden');
        this.classList.remove('is-playing', 'is-finished');
        const template = this.querySelector(this.mediaQuery.matches ? '[data-desktop-video]' : '[data-mobile-video]');
        if (!template || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.videoStage.append(template.content.cloneNode(true));
        const video = this.videoStage.querySelector('video');
        this.video = video;
        if (!video) return;
        const finish = (repeat = false) => {
          if (signal.aborted || !this.isConnected) return;
          video.pause();
          this.classList.remove('is-playing');
          this.classList.add('is-finished');
          this.videoStage.inert = true;
          this.videoStage.setAttribute('aria-hidden', 'true');
          this.banner.inert = false;
          this.banner.removeAttribute('aria-hidden');
          clearTimeout(this.hideTimer);
          this.hideTimer = setTimeout(() => {
            this.videoStage.hidden = true;
          }, 650);
          clearTimeout(this.repeatTimer);
          if (repeat) {
            const bannerDuration = Number(this.dataset.bannerDuration) || 5;
            this.repeatTimer = setTimeout(() => {
              if (!signal.aborted && this.isConnected) this.startVideo();
            }, 650 + bannerDuration * 1000);
          }
        };
        video.addEventListener('ended', () => finish(true), { signal });
        video.addEventListener('error', () => finish(), { signal });
        video.controls = false;
        video.removeAttribute('controls');
        video.disablePictureInPicture = true;
        video.disableRemotePlayback = true;
        video.muted = true;
        video.playsInline = true;
        video.loop = false;
        this.videoStage.hidden = false;
        video.addEventListener('playing', () => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (!signal.aborted && !video.paused && !video.ended) this.classList.add('is-playing');
            });
          });
        }, { once: true, signal });
        this.banner.inert = true;
        this.banner.setAttribute('aria-hidden', 'true');
        video.play().catch(() => finish());
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.playbackController?.abort();
        this.mediaQuery?.removeEventListener('change', this.onBreakpointChange);
        this.controller = null;
        clearTimeout(this.hideTimer);
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
